const SESSION_KEY = 'saloni_storefront_session_v1';
const ATTRIBUTION_KEY = 'saloni_storefront_attribution_v1';

export function getStorefrontSessionKey() {
  try {
    let key = localStorage.getItem(SESSION_KEY);
    if (!key) {
      key =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID().replace(/-/g, '').slice(0, 32)
          : `s${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, key);
    }
    return key;
  } catch {
    return null;
  }
}

/**
 * Fire-and-forget storefront analytics event.
 */
export function logStorefrontEvent(action, payload = {}, authToken = null) {
  const sessionKey = getStorefrontSessionKey();
  const body = {
    action,
    session_key: sessionKey,
    ...payload,
  };
  if (authToken) {
    body.session_token = authToken;
  }
  try {
    void fetch('/api/storefront_events.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    });
  } catch {
    /* ignore */
  }
}

export function logProductView({ categorySlug, productId, productName, authToken = null }) {
  if (!categorySlug || !productId) return;
  logStorefrontEvent(
    'product_view',
    {
      category_slug: String(categorySlug),
      product_external_id: String(productId),
      product_name: String(productName || ''),
    },
    authToken
  );
}

export function logSiteSearch({ query, resultCount, authToken = null }) {
  const q = String(query || '').trim();
  if (!q) return;
  logStorefrontEvent(
    'search',
    {
      query: q,
      result_count: Math.max(0, Number(resultCount) || 0),
    },
    authToken
  );
}

export function logSearchClick({ query, categorySlug, productId, productName, authToken = null }) {
  const q = String(query || '').trim();
  if (!q || !categorySlug || !productId) return;
  logStorefrontEvent(
    'search_click',
    {
      query: q,
      category_slug: String(categorySlug),
      product_external_id: String(productId),
      product_name: String(productName || ''),
    },
    authToken
  );
}

export function logFunnelEvent({
  eventType,
  categorySlug = '',
  productId = '',
  productName = '',
  quantity = 1,
  valueAmount = 0,
  authToken = null,
}) {
  if (!eventType) return;
  logStorefrontEvent(
    'funnel',
    {
      event_type: String(eventType),
      category_slug: String(categorySlug || ''),
      product_external_id: String(productId || ''),
      product_name: String(productName || ''),
      quantity: Math.max(1, Number(quantity) || 1),
      value_amount: Math.max(0, Number(valueAmount) || 0),
    },
    authToken
  );
}

export function logSocialClick({ platform, targetUrl, authToken = null }) {
  if (!platform) return;
  logStorefrontEvent(
    'social_click',
    {
      platform: String(platform),
      target_url: String(targetUrl || ''),
    },
    authToken
  );
}

export function logSessionAttribution({ utmSource, utmMedium, utmCampaign, referrer, landingPath, authToken = null }) {
  try {
    if (sessionStorage.getItem(ATTRIBUTION_KEY)) return;
    sessionStorage.setItem(ATTRIBUTION_KEY, '1');
  } catch {
    /* ignore */
  }
  logStorefrontEvent(
    'session_attribution',
    {
      utm_source: String(utmSource || ''),
      utm_medium: String(utmMedium || ''),
      utm_campaign: String(utmCampaign || ''),
      referrer: String(referrer || ''),
      landing_path: String(landingPath || ''),
    },
    authToken
  );
}

export function syncGuestCart(items, authToken = null) {
  if (authToken) return;
  const payload = (items || []).map((line) => ({
    category_slug: String(line.categorySlug || line.category_slug || ''),
    product_external_id: String(line.productId || line.product_external_id || ''),
    customization_text: String(line.customization || line.customization_text || ''),
    quantity: Math.max(1, Number(line.qty || line.quantity) || 1),
    product_name: String(line.name || line.product_name || ''),
    unit_price: Number(line.price || line.unit_price) || 0,
    image_url: String(line.image || line.image_url || ''),
  }));
  logStorefrontEvent('sync_guest_cart', { items: payload }, null);
}
